// import type { SpecialAttributeDatabaseEditor } from "@wildboar/meerkat-types";

export
const NOOP = async () => {};

export default NOOP;
